// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.col-dati[data-v-0f5f018e] {\r\n  background-color: white;\r\n  padding: 0px !important;\n}\n.modified-field[data-v-0f5f018e] {\r\n  background-color: rgb(194, 255, 194);\n}\n.deleted-field[data-v-0f5f018e] {\r\n  background-color: gainsboro;\r\n  border-radius: 5px;\n}\r\n", ""]);
// Exports
module.exports = exports;
